lmApp
    .service('URLService', [
        function () {
            var service = {};

            service.parseURL = function(url) {
                var q = url ? url.indexOf("?") : -1;
                if (q === -1)
                    return {
                        url: url,
                        params: []
                    };

                var search = url.substr(q+1);
                var h = search.lastIndexOf("#");
                if (h !== -1)
                    search = search.substr(0, h);

                if (!search)
                    return {
                        url: url,
                        params: []
                    };

                return {
                    url: url.substring(0, q),
                    params: this.parseURLEncodedTextArray(search)
                };
            };

            service.parseURLEncodedTextArray = function(text) {
                var params = [];

                text = text.replace(/\+/g, " ");

                var args = text.split("&");
                for (var i = 0; i < args.length; ++i) {
                    try {
                        var parts = args[i].split("=");
                        if (parts.length === 2) {
                            params.push({name: decodeURIComponent(parts[0]), value: [decodeURIComponent(parts[1])]});
                        }
                        else
                            params.push({name: decodeURIComponent(parts[0]), value: [""]});
                    }
                    catch (e) {
                        console.log("parseURLEncodedTextArray exception ", e);
                    }
                }

                params.sort(function(a, b) { return a.name <= b.name ? -1 : 1; });
                return params;
            };

            service.joinURLParams = function(params) {
                var args = [];
                for (var i = 0; i < params.length; ++i) {
                    var name = encodeURIComponent(params[i].name);
                    var value = encodeURIComponent(params[i].value);
                    args.push(name + '=' + value);
                }
                var text = args.join("&");
                return text.replace(" ", "+");
            };

            return service;
        }]);
